import './css/common.css'

import React from "react"

const Forbidden = () => {
    window.location.href = process.env.REACT_APP_AUTH_URL;
}
export default Forbidden;